function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 20C4.48578 20 0 15.5142 0 10C0 4.48578 4.48578 0 10 0C15.5142 0 20 4.48578 20 10C20 15.5142 15.5142 20 10 20ZM10 1.25C5.17502 1.25 1.25 5.17502 1.25 10C1.25 14.825 5.17502 18.75 10 18.75C14.825 18.75 18.75 14.825 18.75 10C18.75 5.17502 14.825 1.25 10 1.25Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1509 4.95446C11.1509 5.38951 10.7982 5.74218 10.3632 5.74218C9.92812 5.74218 9.57544 5.38951 9.57544 4.95446C9.57544 4.51942 9.92812 4.16675 10.3632 4.16675C10.7982 4.16675 11.1509 4.51942 11.1509 4.95446Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3562 15.1666C10.3584 15.1667 10.3606 15.1667 10.3628 15.1667C10.365 15.1667 10.3672 15.1667 10.3694 15.1666H12.1358C12.4619 15.1666 12.7266 14.9019 12.7266 14.5758C12.7266 14.2497 12.4619 13.985 12.1358 13.985H10.9536V7.87989C10.9536 7.55375 10.6889 7.28906 10.3628 7.28906H8.98425C8.65812 7.28906 8.39343 7.55375 8.39343 7.87989C8.39343 8.20602 8.65812 8.47071 8.98425 8.47071H9.77197V13.985H8.59082C8.26469 13.985 8 14.2497 8 14.5758C8 14.9019 8.26469 15.1666 8.59082 15.1666H10.3562Z"
});

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#A5B1E0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.6123aedd.svg";
export { ForwardRef as ReactComponent };